import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2fde1481")

_pushScopeId("data-v-2fde1481")
const _hoisted_1 = { class: "video-settings" }
const _hoisted_2 = {
  key: 0,
  class: "video-container"
}
const _hoisted_3 = {
  key: 0,
  class: "video",
  ref: "mirrorVideo",
  autoplay: "true",
  playsinline: ""
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Select = _resolveComponent("Select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.devices.videoDisabled)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_ctx.devices.videoEnabled)
            ? (_openBlock(), _createBlock("video", _hoisted_3, null, 512))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Select, {
      class: "select camera",
      modelValue: _ctx.devices.selectedVideoDevice,
      "onUpdate:modelValue": _ctx.updateVideoDevice,
      label: _ctx.t('settings.camera'),
      options: _ctx.devices.videoDevices,
      searchable: false,
      placeholder: _ctx.t('none'),
      disabled: !_ctx.devices.requestDone || _ctx.devices.videoDisabled
    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options", "placeholder", "disabled"]),
    _createVNode(_component_Select, {
      class: "select quality",
      modelValue: _ctx.devices.selectedQuality,
      "onUpdate:modelValue": _ctx.updateVideoQuality,
      label: _ctx.t('settings.quality'),
      options: _ctx.devices.videoQuality,
      searchable: false,
      placeholder: _ctx.t('none'),
      disabled: !_ctx.devices.requestDone || _ctx.devices.videoDisabled
    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "options", "placeholder", "disabled"])
  ]))
})